/* -----------------Child components--------------- */
import type { Confidence } from "@memorang/types";
import Container from "../../Container";
import BottomNavigationSession from "./BottomNavigationSession";
import NavButtons, {
	type NextButtonProps,
	type QuestionsConfig,
} from "./NavButtons";
import SubmitAnswer from "./SubmitAnswer";

interface Props extends NextButtonProps {
	showConfidenceSubmitButtons?: boolean;
	handleConfidenceProvided: (confidence: Confidence) => void;
	handleAiFeedbackProvided: (confidence: Confidence) => void;
	handleGenerateFeedback?: (callback: () => void) => Promise<void>;
	submitAnswerDynamicCta?: string;
	isSummativeTest?: boolean;
	toggleHelpDialog?: () => void;
	inReviewMode?: boolean;
	showSubmitAnswerAIFeedbackButton?: boolean;
	hasParentStem?: boolean;
	handleTrackConfidenceClick: (confidence: Confidence) => void;
	questionsConfig?: QuestionsConfig;
}
const StudySessionBottomAppBar = ({
	handleNext,
	handlePrevious,
	showConfidenceSubmitButtons,
	handleConfidenceProvided,
	isSummativeTest,
	toggleHelpDialog,
	inReviewMode,
	showSubmitAnswerAIFeedbackButton,
	hasParentStem,
	handleAiFeedbackProvided,
	handleGenerateFeedback,
	handleTrackConfidenceClick,
	submitAnswerDynamicCta,
	buttonConfig,
	showPreviousButton,
	nextButtonState,
	questionsConfig,
}: Props) => {
	return (
		<BottomNavigationSession isSummativeTest={isSummativeTest}>
			<Container
				fullWidth={isSummativeTest}
				maxWidth={hasParentStem ? "lg" : "sm"}
			>
				{showSubmitAnswerAIFeedbackButton || showConfidenceSubmitButtons ? (
					<SubmitAnswer
						type={showSubmitAnswerAIFeedbackButton ? "dynamic" : "static"}
						handleConfidenceProvided={handleConfidenceProvided}
						handleAiFeedbackProvided={handleAiFeedbackProvided}
						handleGenerateFeedback={handleGenerateFeedback}
						handleTrackConfidenceClick={handleTrackConfidenceClick}
						cta={submitAnswerDynamicCta || "Submit"}
					/>
				) : (
					<NavButtons
						showPreviousButton={showPreviousButton}
						nextButtonState={nextButtonState}
						buttonConfig={buttonConfig}
						handleNext={handleNext}
						handlePrevious={handlePrevious}
						isSummativeTest={isSummativeTest}
						inReviewMode={inReviewMode}
						toggleHelpDialog={toggleHelpDialog}
						questionsConfig={questionsConfig}
					/>
				)}
			</Container>
		</BottomNavigationSession>
	);
};

export default StudySessionBottomAppBar;
